module.exports = __webpack_public_path__ + "img/incydenty.3ff1a7db.svg";